import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const ColumnSelector = ({
  columnsState,
  allColumns,
  columnSelectionOpened,
  setColumnSelectionOpened,
  setColumnSelectionHovered,
  handleSelectColumn,
  handleSelectAllColumns,
  handleLeavePencil,
}) => (
  <div onClick={(e) => e.stopPropagation()} onMouseOver={(e) => e.stopPropagation()}>
    <i
      className="pointer icon icon-pencil"
      onClick={() => setColumnSelectionOpened(!columnSelectionOpened)}
      onMouseLeave={handleLeavePencil}
    ></i>

    {columnSelectionOpened && (
      <div
        className="white table-options"
        onMouseOver={() => {
          setColumnSelectionOpened(true);
          setColumnSelectionHovered(true);
        }}
        onMouseLeave={() => {
          setColumnSelectionOpened(false);
          setColumnSelectionHovered(false);
        }}
      >
        <div className="table-options-columns-select">
          <div className={classNames('table-options-col', { selected: allColumns })} onClick={handleSelectAllColumns}>
            All Columns
          </div>

          {columnsState.map(
            (col) =>
              !col.alwaysShown &&
              !col.alwaysHidden && (
                <div key={col.id} className="table-options-col-wrapper">
                  <div
                    className={classNames('table-options-col', col.id, {
                      selected: !col.hidden,
                    })}
                    onClick={() => handleSelectColumn(col)}
                  >
                    {col.title}
                    <svg className="svg-icon" width="16" height="16">
                      <use xlinkHref="/images/icons/check.svg#check"></use>
                    </svg>
                  </div>
                </div>
              )
          )}
        </div>
      </div>
    )}
  </div>
);

ColumnSelector.propTypes = {
  columnsState: PropTypes.array.isRequired,
  allColumns: PropTypes.bool.isRequired,
  columnSelectionOpened: PropTypes.bool.isRequired,
  setColumnSelectionOpened: PropTypes.func.isRequired,
  setColumnSelectionHovered: PropTypes.func.isRequired,
  handleSelectColumn: PropTypes.func.isRequired,
  handleSelectAllColumns: PropTypes.func.isRequired,
  handleLeavePencil: PropTypes.func.isRequired,
};

export default ColumnSelector;
